import {
  BLOGGER_CHANNEL_TABS_LIST,
  ENUM_CHANNEL_STATUS,
} from "@entities/channel";
import { BLOGGER_OFFER_TABS_LIST, ENUM_OFFER_STATUS } from "@entities/offer";
import {
  ADV_MANAGER_PROJECT_TABS_LIST,
  ENUM_ADV_MANAGER_PROJECT_STATUS,
  ADV_MY_PROJECT_TABS_LIST,
  ENUM_ADV_MY_PROJECT_STATUS,
  ENUM_PROJECT_TYPES,
  ENUM_MANAGER_PROJECT_TYPES,
  MANAGER_TURNKEY_PROJECT_TABS_LIST,
  AGENCY_MY_PROJECT_TABS_LIST,
  ENUM_AGENCY_PROJECT_TYPES,
  ENUM_AGENCY_PROJECT_STATUS,
} from "@entities/project";
import { ENUM_ROLES } from "@entities/user";
import {
  useGetViewAdvertiserProjectQuery,
  useGetViewBloggerChannelQuery,
  useGetViewBloggerOrderQuery,
  useGetViewManagerProjectQuery,
} from "@entities/views";
import { AddChannel } from "@features/channel";
import {
  BarStatusFilter,
  BarTop,
  BarTypesFilter,
  TurnkeyProject,
} from "@features/other";
import { AddAgencyNewProject, NewProject } from "@features/project";
import { useAppSelector } from "@shared/hooks";
import { ENUM_PAGE_FILTER } from "@shared/routing";
import { FC } from "react";
import styles from "./styles.module.scss";

interface BarFilterProps {
  page: ENUM_PAGE_FILTER;
  listLength?: boolean;
  typeFilter?: ENUM_PROJECT_TYPES | string;
  statusFilter:
    | ENUM_ADV_MANAGER_PROJECT_STATUS
    | ENUM_ADV_MY_PROJECT_STATUS
    | ENUM_CHANNEL_STATUS
    | ENUM_OFFER_STATUS
    | ENUM_AGENCY_PROJECT_STATUS
    | string;
  changeStatus: (
    status:
      | ENUM_ADV_MANAGER_PROJECT_STATUS
      | ENUM_ADV_MY_PROJECT_STATUS
      | ENUM_CHANNEL_STATUS
      | ENUM_OFFER_STATUS
      | ENUM_AGENCY_PROJECT_STATUS
      | string,
  ) => void;
  changeType?: (status: string) => void;
}

export const BarFilter: FC<BarFilterProps> = ({
  page,
  typeFilter,
  statusFilter,
  changeStatus,
  changeType,
}) => {
  const { isAuth, role } = useAppSelector((state) => state.user);

  const { data: viewsAdvProjects } = useGetViewAdvertiserProjectQuery(
    undefined,
    {
      skip: !isAuth || role !== ENUM_ROLES.ADVERTISER,
    },
  );

  const { data: viewsBloggerOffers } = useGetViewBloggerOrderQuery(undefined, {
    skip: !isAuth || role !== ENUM_ROLES.BLOGGER,
  });

  const { data: viewsBloggerChannels } = useGetViewBloggerChannelQuery(
    undefined,
    {
      skip: !isAuth || role !== ENUM_ROLES.BLOGGER,
    },
  );

  const { data: viewsManProjects } = useGetViewManagerProjectQuery(undefined, {
    skip: !isAuth || role !== ENUM_ROLES.MANAGER,
  });

  const badgeStatus =
    page === ENUM_PAGE_FILTER.OFFER
      ? viewsBloggerOffers?.values[0]?.value?.map((item) => {
          return { status: item?.status, count: item?.count };
        })
      : page === ENUM_PAGE_FILTER.PLATFORM
        ? viewsBloggerChannels?.values[0]?.value?.map((item) => {
            return { status: item?.status, count: item?.count };
          })
        : page === ENUM_PAGE_FILTER.ORDER && role === ENUM_ROLES.ADVERTISER
          ? viewsAdvProjects?.values
              .find((project) => project?.type === typeFilter)
              ?.value?.map((item) => {
                return { status: item?.status, count: item?.count };
              })
          : page === ENUM_PAGE_FILTER.ORDER && role === ENUM_ROLES.MANAGER
            ? viewsManProjects?.values[0]?.value?.map((item) => {
                return { status: item?.status, count: item?.count };
              })
            : undefined;

  const badgeType =
    page === ENUM_PAGE_FILTER.ORDER
      ? viewsAdvProjects?.values?.map((item) => {
          return { type: item?.type, count: item?.count };
        })
      : undefined;

  const projectStatus =
    page === ENUM_PAGE_FILTER.ORDER &&
    typeFilter === ENUM_PROJECT_TYPES.MY_PROJECT &&
    role === ENUM_ROLES.ADVERTISER
      ? ADV_MY_PROJECT_TABS_LIST
      : page === ENUM_PAGE_FILTER.ORDER &&
          typeFilter === ENUM_PROJECT_TYPES.MANAGER_PROJECT &&
          role === ENUM_ROLES.ADVERTISER
        ? ADV_MANAGER_PROJECT_TABS_LIST
        : page === ENUM_PAGE_FILTER.ORDER &&
            (role === ENUM_ROLES.MANAGER || role === ENUM_ROLES.AGENCY)
          ? typeFilter === ENUM_MANAGER_PROJECT_TYPES.TURNKEY_PROJECT
            ? MANAGER_TURNKEY_PROJECT_TABS_LIST
            : AGENCY_MY_PROJECT_TABS_LIST
          : page === ENUM_PAGE_FILTER.OFFER
            ? BLOGGER_OFFER_TABS_LIST
            : BLOGGER_CHANNEL_TABS_LIST;

  return (
    <div className={styles.wrapper}>
      <BarTop
        listLength={true}
        NewProjectBtn={NewProject}
        TurnkeyProjectBtn={TurnkeyProject}
        AddChannelBtn={AddChannel}
        page={page}
        AddAgencyNewProjectBtn={
          page === ENUM_PAGE_FILTER.ORDER &&
          role === ENUM_ROLES.AGENCY &&
          typeFilter === ENUM_AGENCY_PROJECT_TYPES.MY_PROJECT
            ? AddAgencyNewProject
            : undefined
        }
      />
      {page === ENUM_PAGE_FILTER.ORDER ? (
        <>
          <BarTypesFilter
            changeStatus={changeStatus}
            changeType={changeType!}
            typeFilter={typeFilter!}
            badge={badgeType}
            role={role}
          />
          {typeFilter === ENUM_PROJECT_TYPES.SAVED_PROJECT || (
            <BarStatusFilter
              changeStatus={(v) => changeStatus(String(v))}
              statusFilter={statusFilter}
              projectStatus={projectStatus}
              badge={badgeStatus}
            />
          )}
        </>
      ) : (
        <BarStatusFilter
          changeStatus={(v) => changeStatus(String(v))}
          statusFilter={statusFilter}
          projectStatus={projectStatus}
          badge={badgeStatus}
        />
      )}
    </div>
  );
};
